module.exports = __webpack_public_path__ + "img/DO.f5b3a7b5.svg";